import ChevronRight from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { RelatedLink } from 'pages/flex-data/flex-data-links/types';
import { LinkCrmObjectModal } from '../LinkCrmObjectModal/LinkCrmObjectModal';

interface LinkCrmButtonProps {
  contentId: string;
  hasLinkedObjects: boolean;
  onLinked?: (relatedLinks: RelatedLink[]) => void;
}

export function LinkCrmButton({ contentId, hasLinkedObjects, onLinked }: LinkCrmButtonProps) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {hasLinkedObjects ? (
        <Box>
          <Button variant="text" color="primary" size="medium" endIcon={<ChevronRight />} onClick={() => setIsModalOpen(true)}>
            {t('editor.side_panel.link_an_app.add_more_links')}
          </Button>
        </Box>
      ) : (
        <Button variant="outlined" color="secondary" fullWidth onClick={() => setIsModalOpen(true)}>
          {t('editor.side_panel.link_an_app.link_crm_button')}
        </Button>
      )}
      {isModalOpen && (
        <LinkCrmObjectModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} contentId={contentId} onLinked={onLinked} />
      )}
    </>
  );
}
